import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-video-coaching',
  templateUrl: './video-coaching.component.html',
  styleUrls: ['./video-coaching.component.scss']
})
export class VideoCoachingComponent implements OnInit {

  @Input() url: any;
  dangerousVideoUrl;
  videoUrl;
  id;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.updateVideoUrl(this.url);
  }

  updateVideoUrl(url: string) {
    const type = url.split('/')[3].split('?')[0];
    const id = url.split('=')[1];

    switch (type) {
      case 'watch':
        this.dangerousVideoUrl = 'https://www.youtube.com/embed/' + id;

        break;
      case 'playlist':
        this.dangerousVideoUrl = 'https://www.youtube.com/embed/list?list=' + id;

        break;

      default:
        break;
    }
    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.dangerousVideoUrl);
  }
}
